import { Tag, TagCloseButton, TagLabel } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import {
    chipTagCloseButtonSxStyles as tagCloseButtonSxStyles,
    chipTagCloseButtonStyles as tagCloseButtonStyles,
    chipTagStyles as tagStyles,
} from '@/chakratheme';

export const Chip = ({ input, index, onCloseClick, isDisabled }) => {
    const { darkMode } = useSelector((state) => state.settings);

    return (
        <Tag
            margin="1 !important"
            key={input}
            borderRadius="full"
            variant="solid"
            {...tagStyles(darkMode)}>
            <TagLabel>{input}</TagLabel>
            <TagCloseButton
                className="btn-sm"
                {...tagCloseButtonStyles(darkMode)}
                sx={tagCloseButtonSxStyles}
                isDisabled={isDisabled}
                onClick={() => {
                    onCloseClick(input, index);
                }}
            />
        </Tag>
    );
};
